import {_POST, _GET, _PUT} from "./Api"

export const AppApi = {

    authToken: `Bearer ${localStorage.getItem('jwtToken')}`,

    pub: {

        getAgb: () => _GET("/modules/bildungsurlaub/api/agb"),
        getImpressum: () => _GET("/modules/bildungsurlaub/api/impressum"),
        getDatenschutz: () => _GET("/modules/bildungsurlaub/api/datenschutz"),



        urlForm: '/modules/formedy/api/forms',
        getForms: (filter) => _GET(AppApi.pub.urlForm, filter),
        getForm: (id, filter) => _GET(AppApi.pub.urlForm+"/" + id, filter),
        putForm: (body) => _PUT(AppApi.pub.urlForm, body),


        urlTrips: '/modules/bildungsurlaub/api/trips',
        getTrips: (filter) => _GET(AppApi.pub.urlTrips, filter),
        getTrip: (id, filter) => _GET(AppApi.pub.urlTrips+"/" + id, filter),
        putTrip: (body) => _PUT(AppApi.pub.urlTrips, body),

        urlTripOptionLocations: '/modules/bildungsurlaub/api/trip/option/locations',
        getTripOptionLocations: (filter) => _GET(AppApi.pub.urlTripOptionLocations, filter),
        urlTripOptionStates: '/modules/bildungsurlaub/api/trip/option/states',
        getTripOptionStates: (filter) => _GET(AppApi.pub.urlTripOptionStates, filter),

        urlBookings: '/modules/bildungsurlaub/api/bookings',
        getBookings: (filter) => _GET(AppApi.pub.urlBookings, filter, AppApi.authToken),
        getBooking: (id, filter) => _GET(AppApi.pub.urlBookings+"/" + id, filter),
        postBookingRequest: (body) => _POST(AppApi.pub.urlBookings+':requests', body),
        postBookingConfirm: (body) => _POST(AppApi.pub.urlBookings+':confirm', body),
        urlBookingEvents: '/modules/bildungsurlaub/api/booking/events',
        postBookingEvent: (body) => _POST(AppApi.pub.urlBookingEvents, body),
    },
}